import React from 'react';
import PropTypes from 'prop-types';

const List = ({
  typeLabel,
  hoursLabel,
  areaLabel,
  elevationGainLabel,
  timeLabel,
  liftStatuses,
  getIcon
}) => (
  <ul className="lift-status-report__list">
    {liftStatuses.map(lift => (
      <li key={lift.liftName}>
        <h3 className="lift-status-report__table-name">
          <svg
            className={`lift-status-report__${lift.status.toLowerCase()}-icon`}
          >
            <title>list</title>
            <use xlinkHref={getIcon(lift.status)} />
          </svg>
          {lift.liftName}
        </h3>

        <div className="lift-status-report__table-cell">
          <p className="lift-status-report__table-label">{typeLabel}</p>
          <p className="lift-status-report__table-value">{lift.type}</p>
        </div>
        <div className="lift-status-report__table-cell">
          <p className="lift-status-report__table-label">{hoursLabel}</p>
          <p className="lift-status-report__table-value">
            {lift.hoursOfOperation}
          </p>
        </div>
        <div className="lift-status-report__table-cell">
          <p className="lift-status-report__table-label">{areaLabel}</p>
          <p className="lift-status-report__table-value">{lift.area}</p>
        </div>
        <div className="lift-status-report__table-cell">
          <p className="lift-status-report__table-label">
            {elevationGainLabel}
          </p>
          <p className="lift-status-report__table-value">
            {lift.elevationGainFeet} ft./{lift.elevationGainMeters} m
          </p>
        </div>
        <div className="lift-status-report__table-cell">
          <p className="lift-status-report__table-label">{timeLabel}</p>
          <p className="lift-status-report__table-value">{lift.time}</p>
        </div>
      </li>
    ))}
  </ul>
);

List.propTypes = {
  typeLabel: PropTypes.string.isRequired,
  hoursLabel: PropTypes.string.isRequired,
  areaLabel: PropTypes.string.isRequired,
  elevationGainLabel: PropTypes.string.isRequired,
  timeLabel: PropTypes.string.isRequired,
  liftStatuses: PropTypes.array.isRequired,
  getIcon: PropTypes.func.isRequired
};

export default List;
